import type { ReactElement } from 'react';
import { RouterProvider } from '@tanstack/react-router';

import { router } from '@/libs/router.service';

export function AppRouterProvider(): ReactElement {
  return <RouterProvider router={router} />;
}
